import { jsx as _jsx } from "react/jsx-runtime";
import enviro from 'enviro';
import { useSelector } from 'react-redux'; // @ts-expect-error Cannot find declaration for module

import FeedbackLoader from 'feedback-loader'; // @ts-expect-error Cannot find declaration for module

import { getIsUngatedForDndAreasInCustomEmailTemplates } from 'DesignData/selectors/gates';

const debugLog = message => {
  if (enviro.debug('FEEDBACK_LOADER')) {
    console.log(message);
  }
};

const FEEDBACK_ID = 918;

const DndAreasInCustomTemplatesFeedback = () => {
  const isUngatedForDndAreasInCustomEmailTemplates = useSelector(getIsUngatedForDndAreasInCustomEmailTemplates);
  const shouldRender = enviro.isProd() && isUngatedForDndAreasInCustomEmailTemplates;

  if (!shouldRender) {
    return null;
  }

  return /*#__PURE__*/_jsx(FeedbackLoader, {
    onClientLoad: feedbackClient => {
      debugLog(`Feedback client loaded, triggering survey ${FEEDBACK_ID}`);
      feedbackClient.loadSurvey('CSAT', FEEDBACK_ID);
    }
  });
};

export default DndAreasInCustomTemplatesFeedback;